<template>
    <div class="ds-alert">
        <b-alert
                :show="dismissCountDown"
                dismissible
                fade
                class="p-4 shadow-sm"
                :variant="alertType"
                @dismissed="dismissCountDown = 0"
                @dismiss-count-down="countDownChanged">
            <p class="m-0">{{ alertMessage }}</p>
            <router-link v-if="linkData.routeName" class="text-dark font-weight-bold mt-2" :to="{name: linkData.routeName}">
                <span @click="closeAlert">{{ linkData.linkTitle }}</span>
            </router-link>
        </b-alert>
    </div>
</template>
<script>
    import * as rootStoreTypes from '../../vuex/root.store-types';

    export default {
        name: 'alert',
        data: () => ({
            dismissSecs: 2,
            alertMessage: '',
            alertType: '',
            dismissCountDown: 0,
            linkData: {
                routeName: '',
                linkTitle: '',
            }
        }),
        created() {
            this.$store.subscribe((mutation, state) => {
                if (mutation.type === rootStoreTypes.SET_ALERT_DATA) {
                    this.alertMessage = state.alertData.message;
                    this.alertType = state.alertData.type;
                    this.dismissSecs = state.alertData.dismissSecs || 2;

                    if (state.alertData.linkData) {
                        this.linkData = state.alertData.linkData;
                    }

                    this.showAlert();
                }
            });
        },
        methods: {
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown;
            },
            showAlert() {
                this.dismissCountDown = this.dismissSecs;
            },
            closeAlert() {
                this.dismissCountDown = 0;
            }
        }
    }
</script>